import { Schulform } from "@core";

export const schulformenGymOb = [Schulform.FW, Schulform.GE, Schulform.GY, Schulform.SG, Schulform.WF] as const;